import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-sales-phone-enrollment-manual-questions-process',
  templateUrl: './sales-phone-enrollment-manual-questions-process.component.html',
  styles: [
  ]
})
export class SalesPhoneEnrollmentManualQuestionsProcessComponent {
  visibleModalEndProcess = true;

  @Output() step = new EventEmitter();

  constructor() {

  }

  onContinueEnrollment() {
    this.step.emit('in-progress');
  }

  onReturnEnrollment() {
    this.step.emit('init-enrollment-knox');

  }
}
